import apiClient from './client';

export const licenseApi = {
  // Get license status (public, for app init)
  getStatus() {
    return apiClient.get('/license/status');
  },

  // Get full license details (admin only)
  getDetails() {
    return apiClient.get('/license');
  },

  // Activate license key (admin only)
  activate(licenseKey, validationUrl = null) {
    return apiClient.post('/license/activate', {
      licenseKey,
      validationUrl,
    });
  },

  // Force re-validation against external server (admin only)
  validate() {
    return apiClient.post('/license/validate');
  },
};

export default licenseApi;
